import React from 'react';
import { Phone, Clock, Facebook, Instagram, Youtube, User, ShoppingCart, Menu } from 'lucide-react';
export function Header() {
  return <header className="w-full bg-charcoal relative z-50" data-id="element-80">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-4" data-id="element-81">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6 lg:gap-0" data-id="element-82">
          {/* Logo Section */}
          <div className="flex items-center flex-shrink-0" data-id="element-83">
            <img src="https://cdn.magicpatterns.com/uploads/q4av7SXkTh841TBiCeZ1dj/PRO-Logo.png" alt="Pro One Design" className="h-24 md:h-32 w-auto object-contain" data-id="element-84" />
          </div>

          {/* Center Info Blocks - Hidden on mobile, visible on lg */}
          <div className="hidden lg:flex items-center gap-12" data-id="element-85">
            <div className="flex items-center gap-3 group" data-id="element-86">
              <div className="bg-white/5 p-2 rounded-full group-hover:bg-primary/20 transition-colors" data-id="element-87">
                <Phone className="w-5 h-5 text-primary" data-id="element-88" />
              </div>
              <div className="flex flex-col" data-id="element-89">
                <span className="text-[10px] font-bold text-primary uppercase tracking-wider italic" data-id="element-90">
                  Need Support?
                </span>
                <span className="text-lg font-heading font-bold text-white leading-none italic group-hover:text-primary transition-colors" data-id="element-91">
                  (559) 123-4567
                </span>
              </div>
            </div>

            <div className="flex items-center gap-3 group" data-id="element-92">
              <div className="bg-white/5 p-2 rounded-full group-hover:bg-primary/20 transition-colors" data-id="element-93">
                <Clock className="w-5 h-5 text-primary" data-id="element-94" />
              </div>
              <div className="flex flex-col" data-id="element-95">
                <span className="text-[10px] font-bold text-primary uppercase tracking-wider italic" data-id="element-96">
                  Open Daily
                </span>
                <span className="text-lg font-heading font-bold text-white leading-none italic" data-id="element-97">
                  8:00AM-5:00PM
                </span>
              </div>
            </div>
          </div>

          {/* Right Actions */}
          <div className="flex items-center gap-4 lg:gap-6" data-id="element-98">
            {/* Social Icons */}
            <div className="flex items-center gap-3" data-id="element-99">
              {[Facebook, Instagram, Youtube].map((Icon, i) => <a key={i} href="#" className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-full hover:border-primary hover:text-primary transition-colors text-gray-400" data-id="element-100">
                  <Icon className="w-4 h-4" data-id="element-101" />
                </a>)}
            </div>

            {/* Shop Button */}
            <button className="hidden sm:block px-8 py-2 bg-primary text-white rounded-sm font-heading font-bold text-lg tracking-wide hover:bg-white hover:text-charcoal transition-colors uppercase italic skew-x-[-10deg]" data-id="element-102">
              <span className="block skew-x-[10deg]" data-id="element-103">Shop Now</span>
            </button>

            {/* User Actions */}
            <div className="flex items-center gap-4 text-gray-400" data-id="element-104">
              <button className="hover:text-primary transition-colors" data-id="element-105">
                <User className="w-6 h-6" data-id="element-106" />
              </button>
              <button className="hover:text-primary transition-colors relative" data-id="element-107">
                <ShoppingCart className="w-6 h-6" data-id="element-108" />
                <span className="absolute -top-1 -right-1 w-4 h-4 bg-primary text-white text-[10px] flex items-center justify-center rounded-full font-bold italic" data-id="element-109">
                  0
                </span>
              </button>
              <button className="lg:hidden hover:text-primary transition-colors" data-id="element-110">
                <Menu className="w-6 h-6" data-id="element-111" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>;
}